import { toast } from '@foam/buoy/src/components/Toast/Toast';
import {
  CONVERSATION_STARTERS_OPEN_SIDEPANEL_DELAY,
  FOAM_ASSIST_CHROME_STORE_URL,
} from '~/constants/extension';
import { captureException } from '~/errorsLogging';
import { foamExtensionUtils } from '~/extensionUtils';
import { ConvStarterActionTypes, StarterData } from '~/types/extension';

interface UseConversationStarterActionOptions {
  feature: string;
  action: string;
  onError?: () => void;
}

export const useConversationStarterAction = () => {
  const handleConversationStarterAction = <
    StarterType extends ConvStarterActionTypes,
  >(
    actionType: StarterType,
    data: StarterData<StarterType>,
    options: UseConversationStarterActionOptions,
  ) => {
    const { feature, action, onError } = options;

    try {
      foamExtensionUtils.sendOpenOnFoamAssist(true);
      setTimeout(() => {
        foamExtensionUtils.sendConversationStarterAction(actionType, data);
      }, CONVERSATION_STARTERS_OPEN_SIDEPANEL_DELAY);
    } catch (error) {
      captureException(error, {
        tags: {
          feature,
          action,
        },
      });
      if (onError) {
        onError();
      } else {
        toast(
          'Failed to open Foam Assist. Check if it is properly installed and enabled in your browser.',
          {
            variant: 'warning',
            actionLabel: 'Go to Chrome Web Store',
            onAction: () => {
              window.open(FOAM_ASSIST_CHROME_STORE_URL, '_blank');
            },
          },
        );
      }
    }
  };

  return { handleConversationStarterAction };
};
